import { render, staticRenderFns } from "./EditPrimarySchool.vue?vue&type=template&id=df5a3fb8&scoped=true&"
import script from "./EditPrimarySchool.vue?vue&type=script&lang=js&"
export * from "./EditPrimarySchool.vue?vue&type=script&lang=js&"
import style0 from "./EditPrimarySchool.vue?vue&type=style&index=0&id=df5a3fb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df5a3fb8",
  null
  
)

export default component.exports